export default __webpack_public_path__ + "static/media/mehdifbphoto.1e9b9f64.jpg";